import * as z from "zod/v4";

export const LogicalQueryTableNameSchema = z.enum([
  "orders",
  "order_customer_classifications",
  "return_facts",
  "return_compensation_methods",
  "return_order_facts",
  "return_order_line_items",
  "merchant_line_items",
  "order_product_reports",
  "return_line_items",
  "return_product_reports",
  "returns",
  "return_reports",
]);

export type LogicalQueryTableName = z.infer<typeof LogicalQueryTableNameSchema>;

export const LogicalQueryScalarValueSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.null(),
]);

export type LogicalQueryScalarValue = z.infer<
  typeof LogicalQueryScalarValueSchema
>;

export const LogicalQueryDatePartSchema = z.enum([
  "day",
  "week",
  "month",
  "quarter",
  "year",
]);

export const LogicalQueryComparisonOperatorSchema = z.enum([
  "eq",
  "neq",
  "gt",
  "gte",
  "lt",
  "lte",
  "like",
  "ilike",
  "in",
  "not_in",
  "is_null",
  "is_not_null",
]);

export const LogicalQueryFunctionNameSchema = z.enum([
  "array_contains",
  "coalesce",
  "current_date",
  "current_timestamp",
  "date_add",
  "date_floor",
  "safe_divide",
  "primary_return_reason",
  "secondary_return_reason",
  "if",
  "year",
]);

export const LogicalQueryCastTypeSchema = z.enum([
  "boolean",
  "date",
  "json",
  "number",
  "string",
  "timestamp",
]);

export const LogicalQueryBinaryOperatorSchema = z.enum([
  "add",
  "subtract",
  "multiply",
  "divide",
]);

export const LogicalQuerySortDirectionSchema = z.enum(["asc", "desc"]);
